import React from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { ProjectIcon } from "../../../../components/IconsSVG";
import AdminDropdown from "../../../../partials/content/CustomDropdowns/AdminDropdown";
import CrudActions from "../../../../partials/datatable/CrudActions";
import Datatable from "../../../../partials/datatable/Datatable";
import {
	StyledTableCell,
	StyledTableRow
} from "../../../../partials/datatable/styles";
import { MutantApiService } from "../../../../services/MutantApiService";
import store from "../../../../store/store";
import Loading from "../../../home/components/Loading";
import { format } from "date-fns";
import "./ProjectsListing.scss";

const initialState = {
	projects: [],
	reload: false,
	loading: true
};

export default class ProjectsListing extends React.Component {
	constructor(props) {
		super(props);
		const { auth } = store.getState();

		this.api = new MutantApiService();

		this.state = {
			...initialState,
			userLogged: auth.user
		};

		this.handleConfirmChangeStatus = this.handleConfirmChangeStatus.bind(this);
		this.formatRow = this.formatRow.bind(this);
		this.setProjects = this.setProjects.bind(this);
	}

	componentDidMount() {
		this.setState({ loading: false });
	}

	handleConfirmChangeStatus = async function(obj) {
		try {
			await this.setState({ loading: true });

			await this.api.makeHttpRequest({
				method: "PUT",
				url: `/project/${obj.id}`
			});

			await this.setState({ loading: false });

			await Swal.fire({
				title: "Sucesso!",
				text: "Status alterado com sucesso.",
				icon: "success",
				cancelButtonText: "Sair"
			});
		} catch (e) {
			await this.setState({ loading: false });
			await Swal.fire("Erro!", "Erro ao alterar status.", "error");
		} finally {
			await this.setState({ reload: !this.state.reload });
		}
	};

	setProjects = projects => {
		this.setState({ projects });
	};

	handleConfirmDelete = async id => {
		try {
			const reqBase = { method: "DELETE", url: `/projects/${id}/` };

			await this.api.makeHttpRequest(reqBase);
			await this.setState({ reload: !this.state.reload });
		} catch (e) {
			await Swal.fire(
				"Erro",
				"Problema ao reverter as alterações, tente mais tarde",
				"error"
			);
		}
	};

	formatRow = project => {
		const crudActions = ["edit", "delete"];
		return (
			<StyledTableRow hover tabIndex={-1} key={project.id}>
				<StyledTableCell scope="row" align="left" width="5%">
					{!!project.id && project.id}
				</StyledTableCell>
				<StyledTableCell
					scope="row"
					align="left"
					width="20%"
					style={{
						fontWeight: "bold"
					}}
				>
					<Link to={`projects/${project.id}/prompts`} className="project-link">
						{!!project.name && project.name}
					</Link>
				</StyledTableCell>
				<StyledTableCell scope="row" align="left" width="40%">
					{!!project.description && project.description}
				</StyledTableCell>
				<StyledTableCell scope="row" align="left" width="20%">
					{!!project.createdAt &&
						format(new Date(project.createdAt), "dd/MM/yyyy hh:mm")}
				</StyledTableCell>
				<StyledTableCell scope="row" width="10%" align="center">
					<CrudActions
						actions={crudActions}
						module="projects"
						id={project.id}
						onConfirmChangeStatus={this.handleConfirmChangeStatus}
						onConfirmDelete={this.handleConfirmDelete}
						obj={project}
					/>
				</StyledTableCell>
			</StyledTableRow>
		);
	};

	render() {
		window.setPageTitle("Listagem de projetos");

		const headRows = [
			{ label: "ID", align: "left"},
			{ label: "NOME", align: "left" },
			{ label: "DESCRIÇÃO", align: "left" },
			{ label: "DATA DE CRIAÇÃO", align: "left" },
			{ label: "AÇÕES", align: "center" }
		];

		return (
			<>
				<Loading isLoading={this.state.loading} />
				<Datatable
					title="Projetos"
					icon={ProjectIcon}
					endpoint="projects"
					className="h-100"
					headRows={headRows}
					formatRow={this.formatRow}
					rows={this.state.projects}
					clietsRows={this.state.clients}
					setRows={this.setProjects}
					reload={this.state.reload}
					placeholderSearch="Filtre por nome ou descrição do projeto"
					mobile={AdminDropdown}
					width={this.props.width}
					hiddenReload
					projects
					buttons={[
						{
							label: "Adicionar",
							onClick: null,
							icone: "add",
							path: "/dashboard/projects/new"
						}
					]}
				/>
			</>
		);
	}
}
